

<template>
  <div class="no-results-found d-flex flex-column justify-content-center align-items-center">
    <h2 class>No Results Found.</h2>
    <img src="../assets/no-results.png" class="my-4" alt="no results" />
    <h5 class="text-itallic">We couldn't find any results matching those criteria.</h5>
  </div>
</template>

<script>
export default {
  methods: {},
  beforeMount() {}
};
</script>

<style scoped>
.no-results-found {
  opacity: 0.5;
}

.no-results-found h5 {
  max-width: 40%;
  text-align: center;
  font-style: italic;
}

.no-results-found img {
  width: 20%;
  height: auto;
}
</style>
